
  import initWasm from " vite/wasm-helper.js"
  export default opts => initWasm(opts, import.meta.ROLLDOWN_FILE_URL_VRAku6fjghkApIISiBWPzg)
  